// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88ca2eb4","826":"22739506"}[chunkId] + ".chunk.js";
};